module.exports = __webpack_public_path__ + "img/ptt.34eed0c6.jpg";